import { configurationService } from '@/data/services/configuration/configuration-service'
import { Configuration } from '@/data/services/configuration/configuration-service-types'

export type SystemConfigurationsLoadDataType = {
  configurations: Configuration.Model[]
}

export async function loadSystemConfigurations(): Promise<SystemConfigurationsLoadDataType> {
  const configurations = await configurationService.getAllFromSystem()
  return { configurations }
}
